import React, { Component } from 'react';
import withAuth from '../../helpers/withAuth';
import LeftSidebar from '../../components/Admin/LeftSidebar';
import {firebase} from '../../firebase';
import LineChart from '../../components/Admin/LineChart';
import { fetchProducts } from '../../methods/api-calls';
import { addProducts, addSubproducts } from "../../store/actions/cartActions";
import SalesInfo from '../../components/Admin/SalesInfo';
import { connect } from "react-redux";
// import RecentOrders from '../../components/Admin/RecentOrders';

class Dashboard extends Component {
    state = {
        ordersData: [],
        loading: true
    };
    async componentDidMount(){
        const db = firebase.firestore();
        const dbOrderRef = db.collection('orders');
        let orderArray = [];
        dbOrderRef.get()
        .then(res => {
            res.forEach(doc => {
                let orderObj = doc.data();
                orderObj.id = doc.id;
                orderArray.push(orderObj)
            });
            this.setState({
                ordersData: orderArray
            })
            this.loading = false;
        })
        .catch(err => {
            console.log('error', err)
        });
        const newProducts = await fetchProducts();
        this.props.addProducts(newProducts)
    }
    render(){
        const chart = this.state.ordersData.length ? <LineChart data={this.state.ordersData} /> : null;
        return(
            <React.Fragment>
                <LeftSidebar />
                  
                <div className="admin-main-content d-flex flex-column">
                    <div className="page-header">
                        <h2>Dashboard</h2>
                    </div>
                    <SalesInfo data={this.state.ordersData} />
                    {/* {chart} */}
                    {/* <RecentOrders /> */}
                   
                   {/* Footer */}
                   <div className="flex-grow-1"></div>
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
	return {
		addProducts: (products) => {
			dispatch(addProducts(products));
        },
        addSubproducts: (subproducts) => {
			dispatch(addSubproducts(subproducts));
		},
	};
};
const WrappedDashboard = withAuth(connect(null, mapDispatchToProps)(Dashboard));
export { WrappedDashboard as Dashboard } 